import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  CreateFleetDefinitionDialogData,
  CreateFleetDefinitionRequest,
  CreateFleetDefinitionResponse,
  ErmDevOpsApiClientService,
  FleetConstantClassCollection,
  FleetDefinition
} from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-create-fleet-definition',
  templateUrl: './create-fleet-definition.component.html',
  styleUrls: ['./create-fleet-definition.component.scss']
})
export class CreateFleetDefinitionComponent {

  isSaving: boolean = false;
  createFleetDefinitionRequest: CreateFleetDefinitionRequest;
  createFleetDefinitionResponse?: CreateFleetDefinitionResponse;
  fleetConstantClassCollection: FleetConstantClassCollection;
  appStreamImages?: string[];

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public createFleetDefinitionDialogData: CreateFleetDefinitionDialogData,
    public dialogRef: MatDialogRef<CreateFleetDefinitionComponent>) {
    let fleetDefaults = createFleetDefinitionDialogData.fleetDefinitionDefaults as FleetDefinition;
    this.fleetConstantClassCollection = createFleetDefinitionDialogData.fleetConstantClassCollection as FleetConstantClassCollection;
    this.appStreamImages = createFleetDefinitionDialogData.appStreamImages;
    this.createFleetDefinitionRequest = {
      accountId: fleetDefaults.accountId,
      fleetKind: fleetDefaults.fleetKind,
      fleetType: fleetDefaults.fleetType,
      instanceType: fleetDefaults.instanceType,
      desiredInstances: fleetDefaults.desiredInstances,
      minCapacity: fleetDefaults.minCapacity,
      maxCapacity: fleetDefaults.maxCapacity,
      disconnectTimeoutInSeconds: fleetDefaults.disconnectTimeoutInSeconds,
      idleDisconnectTimeoutInSeconds: fleetDefaults.idleDisconnectTimeoutInSeconds,
      maxUserDurationInSeconds: fleetDefaults.maxUserDurationInSeconds,
      scaleOutCooldownInSeconds: fleetDefaults.scaleOutCooldownInSeconds,
      scaleInCooldownInSeconds: fleetDefaults.scaleInCooldownInSeconds,
      scaleOutAdjustment: fleetDefaults.scaleOutAdjustment,
      scaleInAdjustment: fleetDefaults.scaleInAdjustment,
      minAvailableCapacityAlarmThreshold: fleetDefaults.minAvailableCapacityAlarmThreshold,
      minAvailableCapacityAlarmEvaluationPeriods: fleetDefaults.minAvailableCapacityAlarmEvaluationPeriods,
      maxAvailableCapacityAlarmThreshold: fleetDefaults.maxAvailableCapacityAlarmThreshold,
      maxAvailableCapacityAlarmEvaluationPeriods: fleetDefaults.maxAvailableCapacityAlarmEvaluationPeriods,
      usesLegacySessionContext: fleetDefaults.usesLegacySessionContext
    } as CreateFleetDefinitionRequest;
  }

  async save(): Promise<void> {
    try {
      this.isSaving = true;
      const createFleetDefinitionResponse = await this.ermDevOpsApiClient.createFleetDefinition(this.createFleetDefinitionRequest);
      this.createFleetDefinitionResponse = createFleetDefinitionResponse.body as CreateFleetDefinitionResponse;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    this.dialogRef.close({ data: this.createFleetDefinitionResponse });
  }
}
